import { buttons } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IButtonData, IButtons } from "../../models/master/buttons";

export default new (class ButtonService {
  public getButton = async (
    id: number
  ): Promise<IApiResponse<IButtonData>> => {
    try {
      let endPoint = urlBinder(buttons.GET_BUTTON, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IButtonData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IButtonData>;
      } else {
        throw error;
      }
    }
  };

  public getAllButtons = async (
    configUserRole?: number,
    pageBlockId?: number,
    collegeId?:number,
    noOfItems?: number
  ): Promise<IApiResponse<Array<IButtons>>> => {
    try {
      let endPoint = urlBinder(buttons.GET_ALL_BUTTONS, [configUserRole,pageBlockId,collegeId,noOfItems]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IButtons>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IButtons>>;
      } else {
        throw error;
      }
    }
  };

  public createButton = async (
    data: IButtonData
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = buttons.CREATE_BUTTON;
      const response = await APIService.post(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateButton = async (
    data: IButtonData, id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(buttons.UPDATE_BUTTON, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateButtonPriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = buttons.UPDATE_BUTTON_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteButton = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(buttons.DELETE_BUTTON, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };

})();
